import React, { Component } from 'react';
import { config as mapConfig } from '../../config/Config';

import {
  VTTContainer,
  VTTWrapper,
  VTTIconBtn,
  VTTMenuIconBtn,
  VTTMenuIconWrapper,
  VTTRow,
  VTTRowBtns,
  VTTSecondaryMenuIconButton,
  VTTSecondaryRowButtons,
  VTTSecondaryMenuButtonFirst,
  VTTSecondaryMenuButtonSecond
} from './VectorTilesToolsElement';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style.js';
import { Draw, Modify } from 'ol/interaction.js';
import { Circle, LineString, Point } from 'ol/geom.js';
import { getArea, getLength, getDistance } from 'ol/sphere.js';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { toLonLat } from 'ol/proj';
import { createBox } from 'ol/interaction/Draw';
import { CardEditButtonWrapper } from '../InformacioDePunt/InformacioPuntCardElement';
import { descarregar } from './VectorTilesUtils';
import { AcceptarButton, OptionsWrapper } from './VTTModalElement';
import { InputWrapper, NameInput, NameText } from '../Navbar/Compartir/ModalPDF/ModalPDFElement';
import { ButtonStyle } from '../Navbar/Compartir/Componentes/Download/Load/LocalMaps/LocalMapsElement';
import { displayComponents } from '../Utils/VisorsUtils';
import GeoJSON from 'ol/format/GeoJSON';
import { convertCircleToPolygon } from '../Utils/MapUtils';
import { getParentURL } from '../Utils/APIUtils';

const style = new Style({
  fill: new Fill({
    color: 'rgba(192, 0, 0, 0.2)'
  }),
  stroke: new Stroke({
    color: 'rgba(192, 0, 0, 1)',
    width: 2
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.2)'
    })
  })
});
const labelStyle = new Style({
  text: new Text({
    font: '14px Calibri,sans-serif',
    fill: new Fill({
      color: 'rgba(255, 255, 255, 1)'
    }),
    backgroundFill: new Fill({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    padding: [3, 3, 3, 3],
    textBaseline: 'bottom',
    offsetY: -15
  }),
  image: new RegularShape({
    radius: 8,
    points: 3,
    angle: Math.PI,
    displacement: [0, 8.5],
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.7)'
    })
  })
});

const borrarStyle = new Style({
  fill: new Fill({
    color: '#FFFFFF60'
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 2
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: '#000000'
    }),
    fill: new Fill({
      color: '#FFFFFF60'
    })
  })
});

const tipStyle = new Style({
  text: new Text({
    font: '12px Calibri,sans-serif',
    fill: new Fill({
      color: 'rgba(255, 255, 255, 1)'
    }),
    backgroundFill: new Fill({
      color: 'rgba(0, 0, 0, 0.4)'
    }),
    padding: [2, 2, 2, 2],
    textAlign: 'left',
    offsetX: 15
  })
});

const modifyStyle = new Style({
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.4)'
    })
  }),
  text: new Text({
    text: `${getTranslatedKey('vectorMod')}`,
    font: '12px Calibri,sans-serif',
    fill: new Fill({
      color: 'rgba(255, 255, 255, 1)'
    }),
    backgroundFill: new Fill({
      color: 'rgba(0, 0, 0, 0.7)'
    }),
    padding: [2, 2, 2, 2],
    textAlign: 'left',
    offsetX: 15
  })
});

const segmentStyle = new Style({
  text: new Text({
    font: '12px Calibri,sans-serif',
    fill: new Fill({
      color: 'rgba(255, 255, 255, 1)'
    }),
    backgroundFill: new Fill({
      color: 'rgba(0, 0, 0, 0.4)'
    }),
    padding: [2, 2, 2, 2],
    textBaseline: 'bottom',
    offsetY: -12
  }),
  image: new RegularShape({
    radius: 6,
    points: 3,
    angle: Math.PI,
    displacement: [0, 7.5],
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.4)'
    })
  })
});
const segmentStyles = [segmentStyle];

let tipPoint;

let draw;

export default class VectorTilesTools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      drawing: false,
      menuOpen: false, //variable de estado (abierto / cerrado) del icono principal de las tools
      iconSelected: null, //variable de estado de que tool está activa
      // modalOpen: false,
      showIcons: true,
      modalText: '',
      isEditing: false,
      editFeature: undefined
    };
    this.drawObj = {
      punt: { type: 'Point', config: {} },
      lliure: { type: 'LineString', config: { freehand: true } },
      linia: { type: 'LineString', config: {} },
      cercle: { type: 'Circle', config: { freehand: true } },
      poligon: { type: 'Polygon', config: {} },
      text: { type: 'Point', config: { text: true } },
      borrar: { type: 'Circle', config: { freehand: true, borrar: true, style: borrarStyle } }
    };
  }
  modify = new Modify({
    source: this.props.vectorTilesSource,
    style: modifyStyle
  });

  componentDidMount() {
    this.modify.set('name', 'vectorModify');

    if (this.props.apiDraw !== 'disable') {
      if (!this.state.menuOpen) this.onMenuIconClick();
      this.setState({ menuOpen: true });
      this.onIconClick(this.props.apiDraw);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isEditing !== this.props.isEditing && this.props.isEditing && this.state.menuOpen) {
      this.onMenuIconClick();
    }
    if (prevProps.apiDraw !== this.props.apiDraw && this.props.apiDraw === 'disable') {
      if (this.state.menuOpen) this.onMenuIconClick();
      this.setState({ iconSelected: null, showIcons: false, drawing: false });
      return;
    }
    if (prevProps.apiDraw !== this.props.apiDraw) {
      if (!this.state.menuOpen) this.onMenuIconClick();
      this.setState({ menuOpen: true });
      this.onIconClick(this.props.apiDraw);
    }
  }

  removeDraw = () => {
    this.setState({ drawing: false });
    this.props.map.removeInteraction(draw);
  };

  formatLength = function (line) {
    const length = getLength(line);
    let output;
    if (length > 1000) {
      output = Math.round((length / 1000) * 100) / 100 + ' km';
    } else {
      output = Math.round(length * 100) / 100 + ' m';
    }
    return output;
  };

  formatArea = function (area) {
    let output;
    if (area > 10000) {
      output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    } else {
      output = Math.round(area * 100) / 100 + ' m\xB2';
    }
    return output;
  };

  formatRadius = (geometry) => {
    let radius = geometry.getRadius();
    radius = radius * 0.74;

    let output;
    if (radius > 1000) {
      output = Math.round((radius / 1000) * 100) / 100 + ' km';
    } else {
      output = Math.round(radius) + ' m';
    }
    return 'Radi: ' + output;
  };

  formatPerimeter = function (polygon) {
    let coordinates = polygon.getCoordinates()[0];
    coordinates = coordinates.map((coord) => {
      return toLonLat(coord, mapConfig.EPSG);
    });

    let perimeter = 0;

    for (var i = 0; i < coordinates.length - 1; i++) {
      perimeter += getDistance(coordinates[i], coordinates[i + 1]);
    }
    let output;
    if (perimeter > 1000) {
      output = Math.round((perimeter / 1000) * 100) / 100 + ' km';
    } else {
      output = Math.round(perimeter) + ' m';
    }
    return output;
  };

  styleFunction(feature, segments, drawType, tip, borrar) {
    const styles = borrar ? [borrarStyle] : [style];
    const geometry = feature.getGeometry();
    const type = geometry.getType();
    let point, label, line;
    if ((!drawType || drawType === type) && this.props.showMedidas) {
      if (type === 'Polygon') {
        const area = getArea(geometry);
        const coordinates = geometry.getCoordinates()[0];
        point = geometry.getInteriorPoint();
        label = coordinates.length > 3 ? 'Àrea: ' + this.formatArea(area) + ' \nPerímetre: ' + this.formatPerimeter(geometry) : null;
        line = new LineString(geometry.getCoordinates()[0]);
      } else if (type === 'LineString') {
        point = new Point(geometry.getLastCoordinate());
        label = this.formatLength(geometry);
        line = geometry;
      } else if (type === 'Circle') {
        point = new Point(geometry.getLastCoordinate());
        label = this.formatRadius(geometry);
      }
    }
    if (segments && line) {
      let count = 0;
      line.forEachSegment((a, b) => {
        const segment = new LineString([a, b]);
        const label = this.formatLength(segment);
        if (segmentStyles.length - 1 < count) {
          segmentStyles.push(segmentStyle.clone());
        }
        const segmentPoint = new Point(segment.getCoordinateAt(0.5));
        segmentStyles[count].setGeometry(segmentPoint);
        segmentStyles[count].getText().setText(label);
        styles.push(segmentStyles[count]);
        count++;
      });
    }

    if (label && this.props.showMedidas) {
      labelStyle.setGeometry(point);
      labelStyle.getText().setText(label);
      styles.push(labelStyle);
    }
    if (tip && type === 'Point' && !this.modify.getOverlay().getSource().getFeatures().length) {
      tipPoint = geometry;
      tipStyle.getText().setText(tip);
      styles.push(tipStyle);
    }
    return styles;
  }

  addInteraction(type, config = {}) {
    let geometryFunction;
    const width = window.innerWidth;
    const activeTip = width >= 768 ? (config.freehand ? '' : getTranslatedKey('vectorInstr')) : getTranslatedKey('vectorInstrTouch');
    let idleTip = width >= 768 ? getTranslatedKey('vectorStart') : getTranslatedKey('vectorStartTouch');
    if (config.text) {
      idleTip = getTranslatedKey('vectorWrite');
    }
    if (config.borrar) {
      geometryFunction = createBox();
      idleTip = getTranslatedKey('vectorDelete');
    }
    if (type === 'Circle' && !config.borrar) {
      idleTip = getTranslatedKey('vectorCircleTooltip');
    }
    if (type === 'LineString' && config.freehand) {
      idleTip = getTranslatedKey('vectorFreeHandTooltip');
    }
    let tip = idleTip;
    draw = new Draw({
      source: config.borrar ? null : this.props.vectorTilesSource,
      type: type,
      ...config,
      style: (feature) => {
        return config.freehand ? this.styleFunction(feature, false, type, tip, config.borrar) : this.styleFunction(feature, true, type, tip);
      },
      dragVertexDelay: width <= 768 ? 85 : 1000, // Con esto, en móvil eliges el punto y arrastrando empiezas a medir
      geometryFunction
    });
    draw.set('name', 'vector');
    this.setState({ drawing: true, showIcons: displayComponents.drawDibuix ? false : true });

    let filter = this.props.map
      .getInteractions()
      .getArray()
      .find(function (interaction) {
        return interaction.get('name') === 'filter';
      });
    if (filter) {
      this.props.map.removeInteraction(filter);
    }
    draw.on('drawstart', () => {
      tip = activeTip;
      if (this.props.showAlert && !this.state.isEditing) {
        this.setState({ modalText: '' });
        const features = this.props.vectorTilesSource.getFeatures();
        const lastFeature = features[features.length - 1];
        this.props.vectorTilesSource.removeFeature(lastFeature);
      }
      this.props.toggleAlert(false);
      this.setState({ isEditing: false });
    });
    draw.on('drawend', async (e) => {
      if (config.borrar) {
        let bbox = e.feature.getGeometry().getExtent();
        this.props.vectorTilesSource.getFeatures().forEach((feature) => {
          let geom = feature.getGeometry();
          if (geom.intersectsExtent(bbox)) {
            this.props.vectorTilesSource.removeFeature(feature);
          }
        });
        if (this.props.vectorTilesSource.getFeatures().length === 0) {
          this.removeDraw();
          this.props.toggleDrawing(false);
          this.setState({ iconSelected: null });
        }
        this.setState({});
      } else {
        if (config.text) {
          const feature = e.feature;
          feature.setProperties({ text: 'Escriu el text' });
          this.modal();
          while (!this.props.showAlert) {
            await new Promise((resolve) => setTimeout(resolve, 50));
          }
          while (this.props.showAlert) {
            await new Promise((resolve) => setTimeout(resolve, 50));
          }
          if (this.state.modalText) {
            feature.setProperties({ text: this.state.modalText });
          } else {
            this.props.vectorTilesSource.removeFeature(feature);
          }
          this.setState({ modalText: '' });
        }
        modifyStyle.setGeometry(tipPoint);
        this.props.map.addInteraction(this.modify);

        this.props.map.once('pointermove', () => {
          modifyStyle.setGeometry();
        });
        tip = idleTip;
        this.setState({});
        if (this.props.apiEnabled && this.props.apiFunctions.drawFeature) {
          let feature = e.feature.clone();
          feature.getGeometry().transform(mapConfig.EPSG_mapa, mapConfig.EPSG);
          if (type === 'Circle') {
            let converted = convertCircleToPolygon(feature.getGeometry());
            feature = new GeoJSON().writeFeature(converted);
          } else {
            feature = new GeoJSON().writeFeature(feature);
          }
          const message = {
            infoName: 'drawFeature',
            data: feature
          };
          window.parent.postMessage(message, getParentURL());
        }
      }
    });
    draw.on('drawabort', (e) => {
      if (config.borrar) {
        let pointClickedCoord = e.feature.getGeometry().getCoordinates()[0][0];
        const pixel = this.props.map.getPixelFromCoordinate(pointClickedCoord);
        this.props.map.forEachFeatureAtPixel(
          pixel,
          (feature) => {
            this.props.vectorTilesSource.removeFeature(feature);
          },
          { layerFilter: undefined, hitTolerance: 10 }
        );
      }
    });

    this.props.toggleDrawing(true);
    this.props.map.addInteraction(draw);
  }

  downloadCheck = () => {
    let features = this.props.vectorTilesSource.getFeatures();
    if (features.length > 0) {
      let count = 0;
      features.forEach((feature) => {
        if (feature.get('text')) {
          count = +1;
        }
      });
      if (count === features.length) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  toggleDownload = () => {
    let features = this.props.vectorTilesSource.getFeatures();
    let count = 0;
    features.forEach((feature) => {
      if (feature.get('text')) {
        count = +1;
      }
    });

    const Component = () => (
      <>
        {count > 0 && <div>Atenció: Els textos sobre el mapa no es guardaran.</div>}
        <CardEditButtonWrapper>
          <ButtonStyle onClick={() => descarregar('json', this.props.vectorTilesSource)}>JSON</ButtonStyle>
          <ButtonStyle onClick={() => descarregar('gml', this.props.vectorTilesSource)}>GML</ButtonStyle>
        </CardEditButtonWrapper>
      </>
    );
    this.props.toggleAlert(true, <Component />, 'Descarregar elements de dibuix en un fitxer', false);
  };

  /**
   * @desc función de estado al clicar el boton principal de las vector tiles tools
   */
  onMenuIconClick = () => {
    this.setState({ active: true });
    this.setState({ menuOpen: !this.state.menuOpen, iconSelected: null }, () => {
      if (this.state.menuOpen === false) {
        this.props.map.removeInteraction(this.modify);
      } else {
        this.props.map.addInteraction(this.modify);
        this.modify.on('modifystart', async (e) => {
          this.setState({ modalText: '', isEditing: true });
          let feature = e.features.getArray()[0];
          this.setState({ editFeature: feature });
          if (feature.get('text') && !this.state.drawing) {
            this.modal(feature.get('text'));
            this.setState({ modalText: feature.get('text') });
            while (!this.props.showAlert) {
              await new Promise((resolve) => setTimeout(resolve, 50));
            }
            while (this.props.showAlert) {
              await new Promise((resolve) => setTimeout(resolve, 50));
            }
            if (feature !== this.state.editFeature) {
              return;
            }
            if (this.state.modalText) {
              feature.setProperties({ text: this.state.modalText });
            } else {
              this.props.vectorTilesSource.removeFeature(feature);
            }
          }
        });
        this.modify.on('modifyend', (e) => {
          this.setState({ isEditing: false });
          if (this.props.apiEnabled && this.props.apiFunctions.drawFeature) {
            let feature = e.features.getArray()[0].clone();

            if (feature.getGeometry() instanceof Circle) {
              feature = convertCircleToPolygon(feature.getGeometry());
            }
            feature.getGeometry().transform(mapConfig.EPSG_mapa, mapConfig.EPSG);
            const message = {
              infoName: 'drawFeature',
              data: new GeoJSON().writeFeature(feature)
            };
            window.parent.postMessage(message, getParentURL());
          }
        });
      }
    });
    this.removeDraw();
    this.setState({ showIcons: true });
    this.props.toggleDrawing(false);
  };

  /**
   * @desc función de estado para indicar que btn tool está activo
   * @param {*} kind
   */
  onIconClick = (kind) => {
    const config = this.drawObj[kind].config;
    const type = this.drawObj[kind].type;

    if (this.state.iconSelected === kind) {
      this.setState({ iconSelected: null });
      this.removeDraw();
      this.props.toggleDrawing(false);
      return;
    } else {
      this.modify.setActive(true);
      this.setState({ iconSelected: kind });

      if (kind === 'borrar') {
        this.modify.setActive(false);
      }

      this.removeDraw();
      this.addInteraction(type, config);
    }
  };

  toggleIcons = () => {
    this.setState({ showIcons: !this.state.showIcons });
  };

  acceptClick = () => {
    this.props.toggleAlert(false);
  };

  inputChange = (e) => {
    this.setState({ modalText: e.target.value }, () => {});
  };

  modal = (text) => {
    if (this.props.showAlert) {
      this.props.toggleAlert(false);
    }
    const Component = () => (
      <OptionsWrapper>
        <InputWrapper>
          <NameText fontSizeEnabled={this.props.fontSizeEnabled}>Text del punt</NameText>
          <NameInput
            fontSizeEnabled={this.props.fontSizeEnabled}
            autoFocus
            placeholder={text ? text : 'Introdueix text del punt...'}
            onChange={(e) => this.inputChange(e)}></NameInput>
          <AcceptarButton onClick={() => this.acceptClick()}>Accepta</AcceptarButton>
        </InputWrapper>
      </OptionsWrapper>
    );
    this.props.toggleAlert(false, null, null, null, () => {
      this.props.toggleAlert(true, <Component />, "Edició d'element al mapa", false);
    });
  };

  render() {
    return (
      <>
        <VTTContainer id="vttcontainer" selected={!this.state.menuOpen} displayNav={this.props.displayNav} visible={displayComponents.einesMesura}>
          <VTTWrapper id="wrapper">
            <VTTRow id="row" selected={!this.state.menuOpen} mesura={displayComponents.drawDibuix}>
              <VTTRowBtns selected={!this.state.menuOpen}>
                <VTTSecondaryMenuButtonFirst id="first" open={!this.state.menuOpen} active={this.state.active} first>
                  {displayComponents.drawDibuix && (
                    <VTTSecondaryMenuIconButton
                      title={getTranslatedKey('redliningHide')}
                      editing={this.props.isEditing}
                      drawing={this.state.drawing}
                      onClick={() => this.toggleIcons()}>
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="26"
                        viewBox="0 0 490 490"
                        fill={this.state.drawing ? '#333333' : 'white'}>
                        <g>
                          <path
                            d="M451,26.2c-18.6-18.5-48.6-18.5-67.1,0L49.5,360.5c-1.4,1.4-2.5,3.3-3,5.2l-26,105.8c-1.5,6,2.2,12.1,8.2,13.5
		                        c1.6,0.4,3.3,0.4,5,0.1l108.9-22.9c2.1-0.4,4.1-1.5,5.6-3l334.3-334.3c18.5-18.6,18.5-48.6,0-67.1L451,26.2z M116.5,408.1
		                        L383,141.6l25.6,25.6L142.1,433.7L116.5,408.1z M75,366.6l266.5-266.5l25.6,25.6L100.7,392.2L75,366.6z M357.3,84.3l13.8-13.8
		                        l67.1,67.1l-13.8,13.8L357.3,84.3z M64.3,387.5l56.5,56.5l-74.2,15.6L64.3,387.5z M466.7,109.1L454,121.8l-67.1-67.1L399.7,42
		                        c9.8-9.8,25.7-9.8,35.5,0l31.6,31.6C476.5,83.4,476.5,99.2,466.7,109.1L466.7,109.1z"
                          />
                        </g>
                      </svg>
                    </VTTSecondaryMenuIconButton>
                  )}
                  <VTTSecondaryRowButtons showIcons={this.state.showIcons} id="buttonsWrap" open={!this.state.menuOpen}>
                    {displayComponents.drawPunt && (
                      <VTTIconBtn
                        id="btn-1"
                        selected={this.state.iconSelected === 'punt'}
                        onClick={() => this.onIconClick('punt')}
                        title={getTranslatedKey('redliningPoint')}
                        enabled
                        className="point-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="28"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          fill={this.state.iconSelected === 'punt' ? '#333333' : 'white'}>
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M125.2,181.1c1.5,0.3,3.1,0.5,4.7,0.7c11.3,0.9,22.2-2.6,30.8-9.9c8.6-7.3,13.8-17.5,14.7-28.8
				c1.8-23-15.1-43.5-38.7-45.5c-23.2-1.9-43.6,15.5-45.5,38.7C89.5,157.7,104.1,177,125.2,181.1z M134.6,124.1
				c0.6,0,1.2,0.1,1.8,0.2c7.8,1.5,13.2,8.6,12.5,16.5c-0.3,4.1-2.3,7.9-5.4,10.6c-3.2,2.7-7.2,4-11.3,3.7
				c-8.7-0.6-14.9-8.3-14.3-16.8S126.1,123.4,134.6,124.1z"
                                />
                              </g>
                            </g>
                          </g>
                          <path
                            id="Click"
                            d="M257.6,420.5c-0.6,0-1.1,0-1.7-0.2c-4.4-0.6-8-3.8-9.3-8.1l-69.3-230.9c-1.2-4.1-0.1-8.5,2.9-11.5
	      c3-3,7.5-4.1,11.5-2.9l230.9,69.4c4.3,1.3,7.5,5,8.1,9.3c0.6,4.4-1.3,8.9-5,11.3l-57.5,38.4l59.3,59.3c4.6,4.6,4.6,11.8,0,16.3
	      l-46.2,46.2c-4.6,4.6-11.8,4.6-16.3,0l-59.3-59.3l-38.5,57.6C265.1,418.6,261.4,420.5,257.6,420.5L257.6,420.5z M303.8,328.2
	      c3.1,0,6,1.2,8.1,3.4l61.1,61.1l29.8-29.8l-61.1-61.1c-2.4-2.4-3.7-5.9-3.3-9.3c0.3-3.4,2.2-6.6,5.1-8.5l48.8-32.6l-186.8-56
	      l56.1,186.9l32.6-48.8c2-2.8,5-4.7,8.5-5.1C303,328.2,303.5,328.2,303.8,328.2L303.8,328.2z"
                          />
                        </svg>
                      </VTTIconBtn>
                    )}
                    {displayComponents.drawLinia && (
                      <VTTIconBtn
                        id="btn-3"
                        enabled
                        title={getTranslatedKey('measureLine')}
                        selected={this.state.iconSelected === 'linia'}
                        onClick={() => this.onIconClick('linia')}
                        className="distance-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="28"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          fill={this.state.iconSelected === 'linia' ? '#333333' : 'white'}>
                          <g>
                            <g>
                              <g>
                                <path d="M43.3,203.7c1.5,0.3,3.1,0.5,4.7,0.7c11.3,0.9,22.2-2.6,30.8-9.9c8.6-7.3,13.8-17.5,14.7-28.8     c1.8-23-15.1-43.5-38.7-45.5c-23.2-1.9-43.6,15.5-45.5,38.7C7.6,180.3,22.2,199.6,43.3,203.7z M52.7,146.7c0.6,0,1.2,0.1,1.8,0.2     c7.8,1.5,13.2,8.6,12.5,16.5c-0.3,4.1-2.3,7.9-5.4,10.6c-3.2,2.7-7.2,4-11.3,3.7c-8.7-0.6-14.9-8.3-14.3-16.8     C36.6,152.4,44.2,146,52.7,146.7z" />
                                <path d="M110.2,175.2c0.8,0.2,1.7,0.2,2.6,0.2l120.9-0.2c7.4,0,13.3-6,13.3-13.4c0-7.4-6-13.3-13.4-13.3l-120.9,0.2     c-7.4,0-13.3,6-13.3,13.4C99.4,168.6,104.1,174,110.2,175.2z" />
                              </g>
                            </g>
                          </g>
                          <path
                            id="Click"
                            d="M335.7,403.1c-0.6,0-1.1,0-1.7-0.2c-4.4-0.6-8-3.8-9.3-8.1l-69.3-230.9c-1.2-4.1-0.1-8.5,2.9-11.5  c3-3,7.5-4.1,11.5-2.9l230.9,69.4c4.3,1.3,7.5,5,8.1,9.3c0.6,4.4-1.3,8.9-5,11.3l-57.5,38.4l59.3,59.3c4.6,4.6,4.6,11.8,0,16.3  l-46.2,46.2c-4.6,4.6-11.8,4.6-16.3,0l-59.3-59.3L345.3,398C343.2,401.2,339.5,403.1,335.7,403.1L335.7,403.1z M381.9,310.8  c3.1,0,6,1.2,8.1,3.4l61.1,61.1l29.8-29.8l-61.1-61.1c-2.4-2.4-3.7-5.9-3.3-9.3c0.3-3.4,2.2-6.6,5.1-8.5l48.8-32.6L283.6,178  l56.1,186.9l32.6-48.8c2-2.8,5-4.7,8.5-5.1C381.1,310.8,381.6,310.8,381.9,310.8L381.9,310.8z"
                          />
                        </svg>
                      </VTTIconBtn>
                    )}
                    {displayComponents.drawArea && (
                      <VTTIconBtn
                        title={getTranslatedKey('measureAr')}
                        id="btn-5"
                        enabled
                        selected={this.state.iconSelected === 'poligon'}
                        onClick={() => this.onIconClick('poligon')}
                        className="area-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="28"
                          fill={this.state.iconSelected === 'poligon' ? '#333333' : 'white'}
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512">
                          <g>
                            <g>
                              <g>
                                <path d="M47.8,148.9c1.6,0,3.2-0.1,4.8-0.3c11.2-1.3,21.3-6.8,28.3-15.6c7-8.8,10.2-19.9,9-31.1C87.2,78.9,66.7,62,43.1,64.6     C19.9,67.2,3.2,88.2,5.8,111.3C8.3,132.7,26.3,148.9,47.8,148.9z M46.1,91.1c0.6-0.1,1.2-0.1,1.8-0.1c7.9,0,14.6,5.9,15.5,13.8     c0.5,4.1-0.7,8.2-3.3,11.4s-6.3,5.3-10.4,5.8c-8.7,1-16.3-5.3-17.2-13.7C31.4,99.8,37.6,92.1,46.1,91.1z" />
                                <path d="M286.8,101.9c1.6,0,3.2-0.1,4.8-0.3c23.2-2.6,39.9-23.6,37.2-46.7c-2.6-23-23.2-39.9-46.7-37.3     c-23.1,2.6-39.9,23.6-37.2,46.7C247.2,85.7,265.3,101.9,286.8,101.9z M285.1,44.1c0.6-0.1,1.2-0.1,1.8-0.1     c7.9,0,14.6,5.9,15.4,13.8c1,8.5-5.2,16.2-13.7,17.2c-8.6,1.1-16.3-5.2-17.2-13.7C270.4,52.8,276.5,45.1,285.1,44.1z" />
                                <path d="M45.9,321C22.7,323.7,6,344.6,8.6,367.8c2.4,21.4,20.4,37.5,41.9,37.5c1.6,0,3.2-0.1,4.8-0.3     c11.2-1.3,21.3-6.8,28.3-15.6c7-8.8,10.2-19.9,9-31.1C90,335.3,69.6,318.3,45.9,321z M62.8,372.7c-2.6,3.3-6.3,5.3-10.4,5.8     c-8.6,0.9-16.2-5.3-17.2-13.7c-1-8.5,5.2-16.2,13.7-17.2c0.6-0.1,1.2-0.1,1.8-0.1c7.9,0,14.6,5.9,15.5,13.8     C66.5,365.4,65.3,369.5,62.8,372.7z" />
                                <path d="M108,108.1c0.9,0,1.7-0.1,2.6-0.3l118.7-23.3c7.2-1.4,11.9-8.4,10.5-15.7c-1.4-7.2-8.4-11.9-15.7-10.5L105.4,81.7     c-7.2,1.4-11.9,8.4-10.5,15.7C96.1,103.7,101.7,108.1,108,108.1z" />
                                <path d="M304.1,106.8c-6.9,2.5-10.5,10.2-8,17.1l36.7,99.8c2,5.4,7.1,8.8,12.5,8.8c1.5,0,3.1-0.3,4.6-0.8     c6.9-2.5,10.5-10.2,8-17.1l-36.7-99.8C318.7,107.9,311,104.3,304.1,106.8z" />
                                <path d="M249.9,318.8l-139.8,22.1c-7.3,1.1-12.3,7.8-11.3,15.1c1,6.6,6.7,11.4,13.2,11.4c0.6,0,1.3-0.1,1.9-0.1l139.8-22.1     c7.3-1.1,12.3-7.8,11.3-15.1C263.9,322.8,257.2,317.8,249.9,318.8z" />
                                <path d="M48.5,156.9c-0.1,0-0.1,0-0.2,0C41,157,35.1,163,35.2,170.4l1.4,129.1c0.1,7.3,6,13.2,13.3,13.2c0.1,0,0.1,0,0.2,0     c7.4-0.1,13.3-6.1,13.2-13.5l-1.4-129.1C61.8,162.8,55.8,156.9,48.5,156.9z" />
                              </g>
                            </g>
                          </g>
                          <path
                            id="Click"
                            d="M328.7,473.5c-0.6,0-1.1,0-1.7-0.2c-4.4-0.6-8-3.8-9.3-8.1l-69.3-230.9c-1.2-4.1-0.1-8.5,2.9-11.5  c3-3,7.5-4.1,11.5-2.9l230.9,69.4c4.3,1.3,7.5,5,8.1,9.3c0.6,4.4-1.3,8.9-5,11.3l-57.5,38.4l59.3,59.3c4.6,4.6,4.6,11.8,0,16.3  l-46.2,46.2c-4.6,4.6-11.8,4.6-16.3,0l-59.3-59.3l-38.4,57.5C336.2,471.7,332.5,473.5,328.7,473.5L328.7,473.5z M374.8,381.2  c3.1,0,6,1.2,8.1,3.4l61.1,61.1l29.8-29.8l-61.1-61.1c-2.4-2.4-3.7-5.9-3.3-9.3c0.3-3.4,2.2-6.6,5.1-8.5l48.8-32.6l-186.9-56.1  l56.1,186.9l32.6-48.8c2-2.8,5-4.7,8.5-5.1C374.1,381.2,374.5,381.2,374.8,381.2L374.8,381.2z"
                          />
                        </svg>
                      </VTTIconBtn>
                    )}
                    {displayComponents.drawCercle && (
                      <VTTIconBtn
                        id="btn-4"
                        enabled
                        title={getTranslatedKey('measureRad')}
                        selected={this.state.iconSelected === 'cercle'}
                        onClick={() => this.onIconClick('cercle')}
                        className="circle-btn">
                        <svg
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          width="28"
                          viewBox="0 0 512 512"
                          fill={this.state.iconSelected === 'cercle' ? '#333333' : 'white'}>
                          <path
                            id="Click"
                            d="M318.7,490c-0.6,0-1.1,0-1.7-0.2c-4.4-0.6-8-3.8-9.3-8.1l-69.3-230.9c-1.2-4.1-0.1-8.5,2.9-11.5
        s7.5-4.1,11.5-2.9l230.9,69.4c4.3,1.3,7.5,5,8.1,9.3c0.6,4.4-1.3,8.9-5,11.3l-57.5,38.4l59.3,59.3c4.6,4.6,4.6,11.8,0,16.3
        l-46.2,46.2c-4.6,4.6-11.8,4.6-16.3,0l-59.3-59.3l-38.5,57.6C326.2,488.1,322.5,490,318.7,490L318.7,490z M364.9,397.7
        c3.1,0,6,1.2,8.1,3.4l61.1,61.1l29.8-29.8l-61.1-61.1c-2.4-2.4-3.7-5.9-3.3-9.3c0.3-3.4,2.2-6.6,5.1-8.5l48.8-32.6l-186.8-56
        l56.1,186.9l32.6-48.8c2-2.8,5-4.7,8.5-5.1C364.1,397.7,364.6,397.7,364.9,397.7L364.9,397.7z"
                          />
                          <g>
                            <g>
                              <path
                                d="M212.3,37.9c99.1-4.9,183.7,71.7,188.6,170.7c0.9,18.3-1,36.1-5.3,53c7.5,2.7,15,5.6,22.4,8.4c5.4-19.9,7.7-41,6.7-62.7
		        C419.2,95.3,323.2,8.5,211.1,14C99.1,19.6,12.2,115.6,17.8,227.6C23.3,339.7,119.3,426.6,231.4,421c9-0.4,17.7-1.5,26.3-3
		        	c-0.4-2.4-0.7-4.8-1.1-7.2c-0.8-5.4-1.7-10.9-2.7-16.3c-7.7,1.4-15.7,2.4-23.8,2.8c-99.1,4.9-183.7-71.7-188.6-170.7
		      S113.3,42.8,212.3,37.9z"
                              />
                            </g>
                          </g>
                        </svg>
                      </VTTIconBtn>
                    )}
                    {displayComponents.drawLliure && (
                      <VTTIconBtn
                        id="btn-2"
                        enabled
                        title={getTranslatedKey('measureFree')}
                        selected={this.state.iconSelected === 'lliure'}
                        onClick={() => this.onIconClick('lliure')}
                        className="free-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="28"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          fill={this.state.iconSelected === 'lliure' ? '#333333' : 'white'}>
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M92.6,238.6c1.4,0.5,3,1,4.5,1.5c11,2.7,22.3,1,32-4.8c9.7-5.8,16.5-15,19.2-26c5.5-22.4-7.8-45.4-30.8-51.2
				c-22.6-5.6-45.5,8.2-51.2,30.8C61.2,209.8,72.5,231.2,92.6,238.6z M111.2,183.9c0.6,0.1,1.2,0.3,1.7,0.5
				c7.5,2.7,11.6,10.6,9.7,18.3c-1,4-3.6,7.4-7.1,9.6c-3.6,2.1-7.8,2.8-11.8,1.8c-8.5-2-13.4-10.6-11.4-18.9
				C94.4,186.9,102.9,181.9,111.2,183.9z"
                                />
                              </g>
                            </g>
                          </g>
                          <path
                            id="Click"
                            d="M232.3,479.7c-0.6,0-1.1,0-1.7-0.2c-4.4-0.6-8-3.8-9.3-8.1L152,240.5c-1.2-4.1-0.1-8.5,2.9-11.5
	      c3-3,7.5-4.1,11.5-2.9l230.9,69.4c4.3,1.3,7.5,5,8.1,9.3c0.6,4.4-1.3,8.9-5,11.3l-57.5,38.4l59.3,59.3c4.6,4.6,4.6,11.8,0,16.3
	      L356,476.3c-4.6,4.6-11.8,4.6-16.3,0L280.4,417l-38.5,57.6C239.8,477.8,236.1,479.7,232.3,479.7L232.3,479.7z M278.5,387.4
	      c3.1,0,6,1.2,8.1,3.4l61.1,61.1l29.8-29.8L316.4,361c-2.4-2.4-3.7-5.9-3.3-9.3c0.3-3.4,2.2-6.6,5.1-8.5l48.8-32.6l-186.8-56
	      l56.1,186.9l32.6-48.8c2-2.8,5-4.7,8.5-5.1C277.7,387.4,278.2,387.4,278.5,387.4L278.5,387.4z"
                          />
                          <path
                            d="M481.6,30.1L481.6,30.1c-6.8-1.9-13.9,2-15.8,8.8L462,52.2c-10.4,36.5-48.5,57.8-85.1,47.5L230.1,58.1
	      c-25.1-7.1-50.7-3.4-71.8,8.4c-21.1,11.8-37.8,31.6-44.9,56.7l-3.8,13.3c-1.9,6.8,2,13.9,8.8,15.8l0,0c6.8,1.9,13.9-2,15.8-8.8
	      l3.8-13.3c10.4-36.5,48.5-57.8,85.1-47.5L370,124.4c50.1,14.2,102.5-15,116.7-65.1l3.8-13.3C492.4,39.1,488.4,32,481.6,30.1z"
                          />
                        </svg>
                      </VTTIconBtn>
                    )}
                    {displayComponents.drawText && displayComponents.drawDibuix && (
                      <VTTIconBtn
                        id="btn-6"
                        enabled
                        title={getTranslatedKey('writeMap')}
                        selected={this.state.iconSelected === 'text'}
                        onClick={() => this.onIconClick('text')}
                        className="text-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="28"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          fill={this.state.iconSelected === 'text' ? '#333333' : 'white'}>
                          <g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M61,118.9c1.4,0.5,3,1,4.5,1.5c11,2.7,22.3,1,32-4.8c9.7-5.8,16.5-15,19.2-26c5.5-22.4-7.8-45.4-30.8-51.2
					c-22.6-5.6-45.5,8.2-51.2,30.8C29.6,90,40.9,111.4,61,118.9z M79.6,64.2c0.6,0.1,1.2,0.3,1.7,0.5C88.8,67.4,92.9,75.3,91,83
					c-1,4-3.6,7.4-7.1,9.6c-3.6,2.1-7.8,2.8-11.8,1.8c-8.5-2-13.4-10.6-11.4-18.9C62.7,67.2,71.3,62.1,79.6,64.2z"
                                  />
                                </g>
                              </g>
                            </g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M421.5,118.9c1.4,0.5,3,1,4.5,1.5c11,2.7,22.3,1,32-4.8c9.7-5.8,16.5-15,19.2-26c5.5-22.4-7.8-45.4-30.8-51.2
					c-22.6-5.6-45.5,8.2-51.2,30.8C390.1,90,401.4,111.4,421.5,118.9z M440.1,64.2c0.6,0.1,1.2,0.3,1.7,0.5
					c7.5,2.7,11.6,10.6,9.7,18.3c-1,4-3.6,7.4-7.1,9.6c-3.6,2.1-7.8,2.8-11.8,1.8c-8.5-2-13.4-10.6-11.4-18.9S431.8,62.1,440.1,64.2
					z"
                                  />
                                </g>
                              </g>
                            </g>
                            <path
                              d="M136.3,93c1,0.2,1.8,0.2,2.8,0.2l232.5,0c7.9,0,14.3-6.4,14.4-14.4c0-7.9-6.4-14.3-14.4-14.4L139,64.6
		      c-7.9,0-14.3,6.4-14.4,14.4C124.6,85.9,129.6,91.7,136.3,93z"
                            />
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M61,480.5c1.4,0.5,3,1,4.5,1.5c11,2.7,22.3,1,32-4.8c9.7-5.8,16.5-15,19.2-26c5.5-22.4-7.8-45.4-30.8-51.2
					c-22.6-5.6-45.5,8.2-51.2,30.8C29.6,451.6,40.9,473,61,480.5z M79.6,425.8c0.6,0.1,1.2,0.3,1.7,0.5c7.5,2.7,11.6,10.6,9.7,18.3
					c-1,4-3.6,7.4-7.1,9.6c-3.6,2.1-7.8,2.8-11.8,1.8c-8.5-2-13.4-10.6-11.4-18.9C62.7,428.8,71.3,423.7,79.6,425.8z"
                                  />
                                </g>
                              </g>
                            </g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M421.5,480.5c1.4,0.5,3,1,4.5,1.5c11,2.7,22.3,1,32-4.8c9.7-5.8,16.5-15,19.2-26c5.5-22.4-7.8-45.4-30.8-51.2
					c-22.6-5.6-45.5,8.2-51.2,30.8C390.1,451.6,401.4,473,421.5,480.5z M440.1,425.8c0.6,0.1,1.2,0.3,1.7,0.5
					c7.5,2.7,11.6,10.6,9.7,18.3c-1,4-3.6,7.4-7.1,9.6c-3.6,2.1-7.8,2.8-11.8,1.8c-8.5-2-13.4-10.6-11.4-18.9
					S431.8,423.7,440.1,425.8z"
                                  />
                                </g>
                              </g>
                            </g>
                            <path
                              d="M136.3,454.6c1,0.2,1.8,0.2,2.8,0.2l232.5,0c7.9,0,14.3-6.4,14.4-14.4c0-7.9-6.4-14.3-14.4-14.4L139,426.1
		        c-7.9,0-14.3,6.4-14.4,14.4C124.6,447.5,129.6,453.3,136.3,454.6z"
                            />
                            <path
                              d="M422,142c-0.2,1-0.2,1.8-0.2,2.8l0,232.5c0,7.9,6.4,14.3,14.4,14.4c7.9,0,14.3-6.4,14.4-14.4l-0.1-232.5
	        c0-7.9-6.4-14.3-14.4-14.4C429.1,130.3,423.3,135.3,422,142z"
                            />
                            <path
                              d="M61.2,142c-0.2,1-0.2,1.8-0.2,2.8l0,232.5c0,7.9,6.4,14.3,14.4,14.4c7.9,0,14.3-6.4,14.4-14.4l-0.1-232.5
	        c0-7.9-6.4-14.3-14.4-14.4C68.3,130.3,62.5,135.3,61.2,142z"
                            />
                          </g>
                          <g>
                            <path
                              d="M351,205c6.7,0,12.2-5.5,12.2-12.2v-47.5c0-6.7-5.5-12.2-12.2-12.2H161c-6.7,0-12.2,5.5-12.2,12.2v47.5
	        c0,6.7,5.5,12.2,12.2,12.2c6.7,0,12.2-5.5,12.2-12.2v-35.3h70.6v203.6h-35.3c-6.7,0-12.2,5.5-12.2,12.2c0,6.7,5.5,12.2,12.2,12.2
		      h95c6.7,0,12.2-5.5,12.2-12.2c0-6.7-5.5-12.2-12.2-12.2h-35.3V157.5h70.6v35.3C338.8,199.5,344.3,205,351,205L351,205z"
                            />
                          </g>
                        </svg>
                      </VTTIconBtn>
                    )}
                    <VTTIconBtn
                      id="btn-7"
                      title={getTranslatedKey('deleteMeasure')}
                      disabled={this.props.vectorTilesSource.getFeatures().length === 0}
                      enabled={this.props.vectorTilesSource.getFeatures().length > 0}
                      selected={this.state.iconSelected === 'borrar'}
                      onClick={() => this.props.vectorTilesSource.getFeatures().length > 0 && this.onIconClick('borrar')}
                      className={this.props.vectorTilesSource.getFeatures().length > 0 ? 'delete-measures-btn' : ''}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        id="Capa_1"
                        width="28"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        fill={
                          this.state.iconSelected === 'borrar'
                            ? '#333333'
                            : this.props.vectorTilesSource.getFeatures().length > 0
                            ? 'white'
                            : '#ffffff50'
                        }>
                        <path
                          d="M130.3,462.6c-9.5,0-17.6-3.4-24.3-10.1c-6.7-6.7-10.1-14.9-10.1-24.3V109.7c0-4.8-3.9-8.6-8.6-8.6H81
	      c-4.8,0-8.6-3.9-8.6-8.6V75.2c0-4.8,3.9-8.6,8.6-8.6h90.7c4.8,0,8.6-3.9,8.6-8.6v0c0-4.8,3.9-8.6,8.6-8.6h134.3
	      c4.8,0,8.6,3.9,8.6,8.6v0c0,4.8,3.9,8.6,8.6,8.6H431c4.8,0,8.6,3.9,8.6,8.6v17.2c0,4.8-3.9,8.6-8.6,8.6h-6.3c-4.8,0-8.6,3.9-8.6,8.6
	      v318.5c0,9.2-3.4,17.2-10.3,24.1c-6.9,6.9-14.9,10.3-24.1,10.3H130.3z M381.7,101H130.3v327.1h251.4V101z M208.4,378.8L208.4,378.8
	      c9.5,0,17.2-7.7,17.2-17.2V167c0-9.5-7.7-17.2-17.2-17.2h0c-9.5,0-17.2,7.7-17.2,17.2v194.6C191.1,371.1,198.9,378.8,208.4,378.8z
	       M303.6,378.8L303.6,378.8c9.5,0,17.2-7.7,17.2-17.2V167c0-9.5-7.7-17.2-17.2-17.2h0c-9.5,0-17.2,7.7-17.2,17.2v194.6
	      C286.4,371.1,294.1,378.8,303.6,378.8z M130.3,101v327.1V101z"
                        />
                      </svg>
                    </VTTIconBtn>
                  </VTTSecondaryRowButtons>
                </VTTSecondaryMenuButtonFirst>
                <VTTSecondaryMenuButtonSecond open={!this.state.menuOpen} active={this.state.active}>
                  {displayComponents.drawDibuix && (
                    <VTTSecondaryMenuIconButton onClick={() => this.toggleIcons()} title={getTranslatedKey('redliningHide')}>
                      <svg version="1.1" id="Capa_2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" viewBox="0 0 490 490" fill="white">
                        <g>
                          <g>
                            <path
                              d="M479.5,203.7l-34.9-5.9c-3.6-11.8-8.3-23.1-14-33.9l20.6-28.8c8.7-12.3,7.4-29-3.3-39.6l-31-31c-5.8-5.8-13.5-9-21.7-9
			      c-6.4,0-12.6,2-17.8,5.7l-28.9,20.6c-11.2-5.9-23-10.8-35.2-14.5l-5.8-34.5C304.8,17.9,292,7.1,277,7.1h-43.8
			      c-15.1,0-27.9,10.8-30.4,25.7l-6,35.4c-11.6,3.6-23,8.4-33.8,14.2l-28.6-20.6c-5.2-3.7-11.4-5.7-17.9-5.7c-8.2,0-16,3.2-21.7,9
			      l-31.1,31c-10.6,10.6-12.1,27.4-3.3,39.6l20.8,29.2c-5.7,10.9-10.3,22.3-13.8,34l-34.5,5.8C17.9,207.3,7,220.1,7,235.1v43.8
			      c0,15.1,10.8,27.9,25.7,30.4l35.4,6c3.6,11.6,8.4,23,14.2,33.8l-20.5,28.5c-8.7,12.3-7.4,29,3.3,39.6l31,31c5.8,5.8,13.5,9,21.7,9
			      c6.4,0,12.6-2,17.8-5.7l29.2-20.8c10.5,5.5,21.5,10,32.9,13.5l5.8,34.9c2.5,14.9,15.3,25.7,30.4,25.7h43.9
			      c15.1,0,27.9-10.8,30.4-25.7l5.9-34.9c11.8-3.6,23.1-8.3,33.9-14l28.8,20.6c5.2,3.7,11.4,5.7,17.9,5.7l0,0c8.2,0,15.9-3.2,21.7-9
			      l31-31c10.6-10.6,12.1-27.4,3.3-39.6L430.3,348c5.7-10.9,10.5-22.3,14-33.9l34.9-5.8c14.9-2.5,25.7-15.3,25.7-30.4v-43.8
			      C505.2,219,494.3,206.2,479.5,203.7z M477.1,277.9c0,1.4-0.9,2.5-2.3,2.7l-43.7,7.3c-5.5,0.9-9.9,5-11.2,10.3
			      c-4,15.3-10,30-18.1,43.6c-2.8,4.8-2.6,10.7,0.6,15.3l25.7,36.2c0.7,1,0.6,2.6-0.3,3.5l-31,31c-0.7,0.7-1.5,0.8-2,0.8
			      c-0.6,0-1.1-0.2-1.6-0.5l-36.1-25.7c-4.5-3.2-10.5-3.4-15.3-0.6c-13.6,8.1-28.3,14.1-43.6,18.1c-5.4,1.4-9.5,5.8-10.3,11.2
			      l-7.4,43.7c-0.2,1.4-1.4,2.3-2.7,2.3h-43.8c-1.4,0-2.5-0.9-2.7-2.3l-7.3-43.7c-0.9-5.5-5-9.9-10.3-11.2
			      c-14.9-3.8-29.2-9.8-42.6-17.5c-2.2-1.2-4.7-1.9-7.1-1.9c-2.8,0-5.7,0.8-8.1,2.6L119.6,429c-0.5,0.3-1,0.5-1.6,0.5
			      c-0.4,0-1.2-0.1-2-0.8l-31-31c-0.9-0.9-1-2.4-0.3-3.5l25.6-35.9c3.2-4.6,3.4-10.6,0.6-15.4c-8.1-13.5-14.4-28.2-18.3-43.5
			      c-1.5-5.3-5.8-9.4-11.2-10.3l-44-7.5c-1.4-0.2-2.3-1.4-2.3-2.7v-43.8c0-1.4,0.9-2.5,2.3-2.7l43.4-7.3c5.5-0.9,10-5,11.3-10.4
			      c3.8-15.3,9.8-30.1,17.8-43.7c2.8-4.8,2.5-10.7-0.7-15.2l-25.9-36.4c-0.7-1-0.6-2.6,0.3-3.5l31-31c0.7-0.7,1.5-0.8,2-0.8
			      c0.6,0,1.1,0.2,1.6,0.5l35.9,25.6c4.6,3.2,10.6,3.4,15.4,0.6c13.5-8.1,28.2-14.4,43.5-18.3c5.3-1.5,9.4-5.8,10.3-11.2l7.5-44
			      c0.2-1.4,1.4-2.3,2.7-2.3h43.8c1.4,0,2.5,0.9,2.7,2.3l7.3,43.4c0.9,5.5,5,10,10.4,11.3c15.7,4,30.7,10.1,44.6,18.3
			      c4.8,2.8,10.7,2.6,15.3-0.6l35.9-25.8c0.5-0.3,1-0.5,1.6-0.5c0.4,0,1.2,0.1,2,0.8l31,31c0.9,0.9,1,2.4,0.3,3.5l-25.7,36.1
			      c-3.2,4.5-3.4,10.5-0.6,15.3c8.1,13.6,14.1,28.3,18.1,43.6c1.4,5.4,5.8,9.5,11.2,10.3l43.7,7.4c1.4,0.2,2.3,1.4,2.3,2.7v43.8
			      H477.1z"
                            />
                            <path
                              d="M256.1,148.5c-59.3,0-107.4,48.2-107.4,107.4s48.2,107.4,107.4,107.4s107.4-48.2,107.4-107.4S315.3,148.5,256.1,148.5z
			      M256.1,335.3c-43.8,0-79.4-35.6-79.4-79.4s35.6-79.4,79.4-79.4s79.4,35.6,79.4,79.4S299.8,335.3,256.1,335.3z"
                            />
                          </g>
                        </g>
                      </svg>
                    </VTTSecondaryMenuIconButton>
                  )}
                  {displayComponents.drawDibuix && (
                    <VTTSecondaryRowButtons showIcons={this.state.showIcons} open={!this.state.menuOpen}>
                      <VTTIconBtn
                        id="btn-8"
                        title={getTranslatedKey('measureDist')}
                        enabled={true}
                        selected={this.props.showMedidas}
                        onClick={() => this.props.toggleMedidas()}
                        className="distance-btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Capa_1"
                          width="24"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          fill={this.props.showMedidas ? '#333333' : 'white'}>
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M404.3,505.3l100.9-100.9c4-4,4-10.3,0-14.3L121.9,6.8c-3.9-3.9-10.3-3.9-14.2,0l-101,101c-2,1.9-2.9,4.5-2.9,7.1
				  c0,2.6,0.9,5.2,2.9,7.1L390,505.2C394,509.1,400.4,509.1,404.3,505.3z M28.2,114.8l86.6-86.6l369.1,369l-86.7,86.7L28.2,114.8z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M142.2,61.4l10.1-10.1c4-4,4-10.3,0-14.3S142,33,138,37l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C131.7,65.3,138.2,65.3,142.2,61.4z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M162.3,121.9l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L148,107.7c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C152,125.8,158.3,125.8,162.3,121.9z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M222.8,142.1l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C212.5,146,218.8,146,222.8,142.1z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M243,202.6l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C232.6,206.6,239.1,206.6,243,202.6z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M303.5,222.7l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C293.2,226.7,299.6,226.7,303.5,222.7z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M323.7,283.3L354,253c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L309.4,269c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C313.3,287.2,319.7,287.2,323.7,283.3z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M384.2,303.5l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L370,289.2c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
				  C373.8,307.4,380.3,307.4,384.2,303.5z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M404.4,364l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
			  	C394.1,367.9,400.4,367.9,404.4,364z"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M464.9,384.2L475,374c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
			  	C454.6,388.1,460.9,388.1,464.9,384.2z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </VTTIconBtn>
                      {displayComponents.drawDonwload && (
                        <VTTIconBtn
                          id="btn-9"
                          title={getTranslatedKey('downloadDraw')}
                          onMouseDown={() => this.setState({ isDownloadClicked: true })}
                          onMouseUp={() => this.setState({ isDownloadClicked: false })}
                          selected={this.state.isDownloadClicked}
                          enabled={this.downloadCheck()}
                          onClick={() => this.downloadCheck() && this.toggleDownload()}
                          className="descarregar-dibuix">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Capa_1"
                            width="24"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            fill={this.downloadCheck() ? 'white' : '#ffffff50'}>
                            <g id="XMLID_26_">
                              <path
                                id="XMLID_27_"
                                d="M243.1,378.2c0.4,0.4,0.9,0.8,1.3,1.2c0.2,0.2,0.4,0.3,0.6,0.5c0.3,0.2,0.5,0.4,0.8,0.6
		        c0.3,0.2,0.5,0.3,0.8,0.5c0.2,0.1,0.5,0.3,0.7,0.4c0.3,0.1,0.6,0.3,0.8,0.4c0.3,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.5,0.2,0.8,0.3
		        c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.1,0.8,0.2c0.3,0.1,0.6,0.2,0.9,0.2c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.5,0.1,0.8,0.1
		        c0.6,0.1,1.2,0.1,1.8,0.1c0.6,0,1.2,0,1.8-0.1c0.3,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,1-0.1c0.3-0.1,0.6-0.1,0.9-0.2
		        c0.3-0.1,0.5-0.1,0.8-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.5-0.2,0.8-0.4c0.3-0.1,0.5-0.3,0.8-0.4
		        c0.3-0.1,0.5-0.3,0.7-0.4c0.3-0.2,0.5-0.3,0.8-0.5c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.4-0.4,0.9-0.7,1.3-1.2
		        c0,0,0,0,0.1-0.1l85.1-85c7.1-7.1,7.1-18.7,0-25.8c-7.1-7.1-18.7-7.1-25.8,0l-53.9,53.9V73.7c0-10.1-8.2-18.2-18.2-18.2
		        c-10.1,0-18.2,8.2-18.2,18.2v247.6l-53.9-53.9c-7.1-7.1-18.7-7.1-25.8,0c-7.1,7.1-7.1,18.7,0,25.8L243.1,378.2z"
                              />
                              <path
                                id="XMLID_28_"
                                d="M438.3,420H73.7c-10.1,0-18.2,8.2-18.2,18.2s8.2,18.2,18.2,18.2h364.5c10.1,0,18.2-8.2,18.2-18.2
		        S448.3,420,438.3,420z"
                              />
                            </g>
                          </svg>
                        </VTTIconBtn>
                      )}
                    </VTTSecondaryRowButtons>
                  )}
                </VTTSecondaryMenuButtonSecond>
              </VTTRowBtns>

              <VTTMenuIconWrapper onClick={() => !this.props.isEditing && this.onMenuIconClick()}>
                <VTTMenuIconBtn
                  editing={this.props.isEditing}
                  id="menu-btn"
                  title={getTranslatedKey('eines')}
                  selected={this.state.menuOpen}
                  onClick={() => !this.props.isEditing && this.onMenuIconClick()}>
                  {displayComponents.drawDibuix ? (
                    <svg
                      version="1.1"
                      id="Capa_33"
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 512.002 512.002"
                      fill={this.state.menuOpen ? '#333333' : 'white'}>
                      <g>
                        <path
                          d="M452.9,22.9c-18.8-18.8-49.3-18.8-68.2,0L45.4,362.3c-1.5,1.5-2.5,3.3-3,5.3L16,475c-1.5,6.1,2.2,12.2,8.3,13.7
		        c1.7,0.4,3.4,0.4,5,0.1l110.5-23.3c2.2-0.5,4.1-1.5,5.7-3.1l339.3-339.3c18.8-18.8,18.8-49.3,0-68.2L452.9,22.9z M113.3,410.6
		        L383.9,140l26,26L139.4,436.6L113.3,410.6z M71.3,368.5L341.8,98l26,26L97.3,394.5L71.3,368.5z M357.8,81.9l14-14l68.1,68.1l-14,14
		        L357.8,81.9z M60.3,389.7l57.3,57.3l-75.3,15.9L60.3,389.7z M468.9,107.1L456,120l-68.1-68.1L400.8,39c10-9.9,26.1-9.9,36.1,0
		        l32,32C478.8,81,478.8,97.1,468.9,107.1L468.9,107.1z"
                        />
                        <g>
                          <g>
                            <g>
                              <path
                                d="M27.9,114.6L114.5,28l135.6,135.6c5.3-4.1,10.7-8.3,15.4-13.1l-144-144c-3.9-3.9-10.3-3.9-14.2,0l-101,101
					c-2,1.9-2.9,4.5-2.9,7.1c0,2.6,0.9,5.2,2.9,7.1l145,145c5.5-3.9,11.3-7.7,16.2-12.3L27.9,114.6z"
                              />
                              <path
                                d="M504.9,389.9L358.3,243.3c-5.2,4.3-9.7,9.2-14.2,14.2L483.6,397l-86.7,86.7L256.7,343.4c-5.7,3.4-10.7,8.2-15.3,13.2
					l148.3,148.3c4,4,10.4,4,14.3,0.1l100.9-100.9C508.9,400.2,508.9,393.9,504.9,389.9z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M141.9,61.2L152,51.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2c0,2.6,0.9,5.2,2.9,7.1
					C131.5,65.1,137.9,65.1,141.9,61.2z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M162,121.7l30.3-30.3c4-4,4-10.3,0-14.3c-4-4-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
					C151.7,125.6,158,125.6,162,121.7z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M222.5,141.8l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
					C212.2,145.8,218.5,145.8,222.5,141.8z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M383.9,303.3l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L369.7,289c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
					C373.5,307.1,380,307.1,383.9,303.3z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M404.1,363.8l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
					C393.8,367.7,400.1,367.7,404.1,363.8z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M464.6,383.9l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
					C454.3,387.9,460.6,387.9,464.6,383.9z"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      id="Capa_1"
                      width="26"
                      viewBox="0 0 512 512"
                      fill={this.state.menuOpen ? '#333333' : 'white'}>
                      <g>
                        <g>
                          <g>
                            <path
                              d="M404.3,505.3l100.9-100.9c4-4,4-10.3,0-14.3L121.9,6.8c-3.9-3.9-10.3-3.9-14.2,0l-101,101c-2,1.9-2.9,4.5-2.9,7.1
 c0,2.6,0.9,5.2,2.9,7.1L390,505.2C394,509.1,400.4,509.1,404.3,505.3z M28.2,114.8l86.6-86.6l369.1,369l-86.7,86.7L28.2,114.8z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M142.2,61.4l10.1-10.1c4-4,4-10.3,0-14.3S142,33,138,37l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C131.7,65.3,138.2,65.3,142.2,61.4z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M162.3,121.9l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L148,107.7c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C152,125.8,158.3,125.8,162.3,121.9z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M222.8,142.1l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C212.5,146,218.8,146,222.8,142.1z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M243,202.6l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C232.6,206.6,239.1,206.6,243,202.6z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M303.5,222.7l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C293.2,226.7,299.6,226.7,303.5,222.7z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M323.7,283.3L354,253c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L309.4,269c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C313.3,287.2,319.7,287.2,323.7,283.3z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M384.2,303.5l10.1-10.1c4-4,4-10.3,0-14.3s-10.3-4-14.3,0L370,289.2c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C373.8,307.4,380.3,307.4,384.2,303.5z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M404.4,364l30.3-30.3c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-30.3,30.3c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C394.1,367.9,400.4,367.9,404.4,364z"></path>
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M464.9,384.2L475,374c4-4,4-10.3,0-14.3s-10.3-4-14.3,0l-10.1,10.1c-2,2-2.9,4.5-2.9,7.2s0.9,5.2,2.9,7.1
 C454.6,388.1,460.9,388.1,464.9,384.2z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  )}
                </VTTMenuIconBtn>
              </VTTMenuIconWrapper>
            </VTTRow>
          </VTTWrapper>
        </VTTContainer>
      </>
    );
  }
}
